import React, { FC, createContext, useContext, useReducer, DispatchWithoutAction, PropsWithChildren } from 'react'
import { WardrunaI } from '../../custom-hooks/usePageDataJson'
import { reducer } from './reducers'

const INITIAL_STATE = {}

export const StateContext = createContext(INITIAL_STATE)

interface WardrunaStateProviderPropsI {
  initialState: WardrunaI
}

export const WardrunaStateProvider: FC<PropsWithChildren<WardrunaStateProviderPropsI>> = ({
  initialState,
  children,
}: PropsWithChildren<WardrunaStateProviderPropsI>) => (
  <StateContext.Provider value={useReducer(reducer, initialState)}>{children}</StateContext.Provider>
)
export const useWardrunaStore: () => [WardrunaI, DispatchWithoutAction] = () =>
  useContext(StateContext) as [WardrunaI, DispatchWithoutAction]
